module.exports = __webpack_public_path__ + "img/administration-t-21360-002-474x317.46de8a96.jpg";